import React, {useCallback} from 'react';
import {Icon, Text} from '@gravity-ui/uikit';
import {CaretDown, CaretUp} from '@gravity-ui/icons';
import {SortOrder, SortProperty} from '../model';
import styles from './SortableHeader.module.scss';

interface SortableHeaderProps {
  title: string;
  property: SortProperty;
  currentProperty?: SortProperty;
  currentOrder?: SortOrder;
  onSort: (property: SortProperty) => void;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  title,
  property,
  currentProperty,
  currentOrder = 'ascending',
  onSort,
}) => {
  const handleClick = useCallback(() => {
    onSort(property);
  }, [onSort, property]);

  const renderSortIcon = () => {
    if (property !== currentProperty) {
      return <Icon data={CaretDown} className={styles.sortIconInactive} />;
    }

    return currentOrder === 'ascending' ? (
      <Icon data={CaretUp} className={styles.sortIconActive} />
    ) : (
      <Icon data={CaretDown} className={styles.sortIconActive} />
    );
  };

  return (
    <div className={styles.sortableHeader} onClick={handleClick}>
      <Text variant="subheader-1">{title}</Text>
      {renderSortIcon()}
    </div>
  );
};
